<template>
    <div class="col-12 col-md-12 col-lg-12">
        <b-card no-body class="skills-card apprentice-simple-card-with-banner">
            <b-card-body body-class="skills-card-body body">
                <div class="muted-text">
                    <p>{{$t('britannica.are_you_looking_for_basic_information_or_very_extensive_sources_with_a_lot_of_background_information_view_the_three_options_to_determine_which_information_is_useful_to_you')}}</p>
                </div>
            </b-card-body>
            <b-card-footer>
                <div class="row">
                    <div class="col-4">
                        <center>
                            <img src="/images/britannica/tree-level-1.png"/>
                            <b-button variant="primary" :href="this.routes.baseUrl() + '/britannica/' + schoolIdIn + '/foundation'" target="_blank">{{$t('britannica.base')}}</b-button>
                        </center>
                    </div>
                    <div class="col-4">
                        <center>
                            <img src="/images/britannica/tree-level-2.png"/><br/>
                            <b-button variant="primary" :href="this.routes.baseUrl() + '/britannica/' + schoolIdIn + '/intermediate'" target="_blank">{{$t('britannica.standard')}}</b-button>
                        </center>
                    </div>
                    <div class="col-4">
                        <center>
                            <img src="/images/britannica/tree-level-3.png"/><br/>
                            <b-button variant="primary" :href="this.routes.baseUrl() + '/britannica/'+ schoolIdIn + '/advanced'" target="_blank">{{$t('britannica.extensive')}}</b-button>
                        </center>
                    </div>
                </div>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "design-2021-britannica-school-component",
    props:[
        'schoolIdIn'
    ]
}
</script>

<style scoped lang="scss">
    .card-footer{
        background-color: transparent;
        border-top: none;
        display: flex;
        align-items: center;
        justify-content: space-evenly;

        .btn{
            &:not(:last-child){
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
</style>
